import { useAppSelector } from "../../../../shared/store";
import { SecondStep } from "./SecondStep";
import { FirstStep } from "./FirstStep";
import styles from "./index.module.scss";

export const CardNumVerification = () => {
  const offerData = useAppSelector((state) => state.payment.offer);

  return (
    <div className={styles.container}>
      {offerData ? (
        offerData.visitorCardNumber ? (
          <SecondStep offer={offerData} />
        ) : (
          <FirstStep offer={offerData} defaultIcon={true} bankName={false} />
        )
      ) : (
        <></>
      )}
      {/* <a href="" className={styles.conditions}>
        Условия оплаты
      </a> */}
    </div>
  );
};
